import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { api, saveSession } from '../api';

export default function AuthVerify() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState<'verifying' | 'error'>('verifying');
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const token = params.get('token');
    if (!token) {
      setStatus('error');
      setError('Missing token in URL.');
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        const result = await api.verifyMagicLink(token);
        if (cancelled) return;
        saveSession({
          token: result.session_token,
          email: result.email,
          expiresAt: result.expires_at,
        });
        navigate('/', { replace: true });
      } catch (err: any) {
        if (cancelled) return;
        setStatus('error');
        setError(err?.message || 'Could not verify link.');
      }
    })();
    return () => { cancelled = true; };
  }, [params, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-sm bg-paper border border-rule p-10 text-center">
        <div className="font-display text-xl font-medium text-ink mb-2">
          Cadence Advisers <span className="italic text-ink-light font-normal">· admin</span>
        </div>

        {status === 'verifying' && (
          <p className="mt-8 font-serif text-sm text-ink-light">Signing you in…</p>
        )}

        {status === 'error' && (
          <>
            <p className="mt-8 font-serif text-sm text-accent">{error}</p>
            <p className="mt-2 font-serif text-sm text-ink-light">
              Magic links expire after 15 minutes and can only be used once.
            </p>
            <a
              href="/login"
              className="inline-block mt-6 font-mono text-[11px] uppercase tracking-wider text-ink-light hover:text-accent"
            >
              ← Request a new link
            </a>
          </>
        )}
      </div>
    </div>
  );
}
